<script>
  import QRCode from 'qrcode';

  export let alt = '';
  export let data = '';

  let src;

  $: if (data) {
    src = '';
    QRCode.toDataURL(data, { margin: 1 }).then((url) => {
      src = url;
    });
  }
</script>

{#if src}
  <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
  <img {src} {alt} {...$$restProps} on:click on:dragstart on:dragover on:dragend on:keydown />
{/if}
